import React from 'react';
import { PrivacyPolicy } from "@kursk/components/pages/PrivacyPolicy/PrivacyPolicy";

export default function PrivacyPolicyPage() {
  return (<PrivacyPolicy />)
}
